import { withData } from 'hocs/withData'
import { ParameterForms as CParameterForms } from './ParameterForms'

export const ParameterForms = withData(CParameterForms)

export default ParameterForms
